import {
  RecoilRoot,
} from 'recoil';

import * as _cr from './_cr';

export const R = (pz: {
  children: React.FC
}) => {
  return (
    _cr.c(RecoilRoot, {
      key: -10,
    },
      pz.children
    )
  )
};
